import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { StorySection } from '../components/StorySection';
import { PainSection } from '../components/PainSection';
import { MechanismSection } from '../components/MechanismSection';
import { SectionDivider } from '../components/SectionDivider';
import { ProductSection } from '../components/ProductSection';
import { AboutSection } from '../components/AboutSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { OfferSection } from '../components/OfferSection';
import { GuaranteeSection } from '../components/GuaranteeSection';
import { UrgencySection } from '../components/UrgencySection';
import { ObjectionsSection } from '../components/ObjectionsSection';
import { IdentitySection } from '../components/IdentitySection';
import { FinalCTASection } from '../components/FinalCTASection';
import { Footer } from '../components/Footer';
import { RecentPurchaseToast } from '../components/RecentPurchaseToast';
export function SalesPage() {
  return <div className="min-h-screen bg-cream font-sans text-dark selection:bg-gold/30 selection:text-forest-dark" data-id="element-582">
      <HeroSection data-id="element-583" />
      <StorySection data-id="element-584" />
      <PainSection data-id="element-585" />
      <MechanismSection data-id="element-586" />
      <SectionDivider data-id="element-587" />
      <AboutSection data-id="element-588" />
      <ProductSection data-id="element-589" />
      <TestimonialsSection data-id="element-590" />
      <OfferSection data-id="element-591" />
      <GuaranteeSection data-id="element-592" />
      <UrgencySection data-id="element-593" />
      <ObjectionsSection data-id="element-594" />
      <IdentitySection data-id="element-595" />
      <FinalCTASection data-id="element-596" />
      <Footer data-id="element-597" />
      <RecentPurchaseToast data-id="element-598" />
    </div>;
}